import React, { useState, useEffect } from "react";
import styles from "./Table.module.sass";
import cn from "classnames";
import Checkbox from "../../../components/Checkbox";
import Row from "./Row";

const Table = ({ 
  className, 
  items = [], 
  onStatusChange, 
  onSelectionChange
}) => {
  const [chooseAll, setСhooseAll] = useState(false);
  const [activeId, setActiveId] = useState(items[0]?.id || null);
  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    if (items.length > 0) {
      if (!activeId || !items.find(item => item.id === activeId)) {
        setActiveId(items[0]?.id || null);
      }
    } else {
      setActiveId(null);
    }
    setSelectedIds([]);
    setСhooseAll(false);
  }, [items, activeId]);

  useEffect(() => {
    onSelectionChange?.(selectedIds);
  }, [selectedIds, onSelectionChange]);

  const handleStatusChange = (id, newStatus) => {
    onStatusChange?.(id, newStatus);
  };

  const handleSelect = (id) => {
    setSelectedIds(prev => {
      const newSelected = prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id];
      setСhooseAll(newSelected.length === items.length && items.length > 0);
      return newSelected;
    });
  };

  const handleSelectAll = () => {
    const newChooseAll = !chooseAll;
    setСhooseAll(newChooseAll);
    setSelectedIds(newChooseAll ? items.map(company => company.id) : []);
  };

  return (
    <div className={cn(styles.wrapper, className)}>
      <div className={cn(styles.table)}>
        <div className={styles.row}>
          <div className={styles.col}>
            <Checkbox
              className={styles.checkbox}
              value={chooseAll}
              onChange={handleSelectAll}
            />
          </div>
          <div className={styles.col}>Entreprise</div>
          <div className={styles.col}>Coordonnées</div>
          <div className={styles.col}>Taille</div>
          <div className={styles.col}>Assigné à</div>
          <div className={styles.col}>Statut</div>
        </div>
        {items.length > 0 ? (
          items.map((x) => (
            <Row
              item={x}
              key={x.id} 
              activeId={activeId}
              activeTable={true}
              selected={selectedIds.includes(x.id)}
              onSelect={handleSelect}
              onStatusChange={handleStatusChange}
              setActiveId={setActiveId}
              setActiveTable={() => {}}
            />
          ))
        ) : (
          <div className={styles.empty}>Aucune entreprise trouvée</div>
        )}
      </div>
    </div>
  );
};

export default Table;